import { ElementType } from "../../library-js/dom-tools/ElementType";
import { HTMLEditor } from "../../library-js/dom-tools/HTMLEditor";
import { VerticalSlider, VerticalSliderElement } from "./VerticalSlider";


export class ValueSlider
{ 
  static readonly type = new ElementType( "value--slider" );
  static readonly nameLabel = new ElementType( "name--label" );
  static readonly valueLabel = new ElementType( "value--label" );

  static setValue( element:Element, value:number, forceUpdate = false )
  {
    let slider = VerticalSlider.type.query( element ) as VerticalSliderElement;
    slider._value.value.value = value;    

    if ( forceUpdate )
    {
      slider._value.value.forceDispatch();
    }
  }

  static getValue( element:Element )
  {
    let slider = VerticalSlider.type.query( element ) as VerticalSliderElement;
    return slider._value.value.value;    
  }

  static updateValue( element:Element )
  {
    let slider = VerticalSlider.type.query( element ) as VerticalSliderElement;
    return slider._value.value.forceDispatch();  
  }

  static setup( element:Element, onChange:( normalizedValue:number ) => string )
  {
    let slider = VerticalSlider.type.query( element ) as VerticalSliderElement;
    let valueLabel = ValueSlider.valueLabel.query( element );

    slider._value.value.addListener(
      ()=>
      {
        let label = onChange( slider._value.value.value );
        HTMLEditor.setText( valueLabel, label );
      }
    );
  }
  
}